var Tools = require('../../deploynaut/js/tools.jsx');
var TeamPage = require('./TeamPage.jsx');
var Profile = require('./Profile.jsx');
var ProfileRegistration = require('./ProfileRegistration.jsx');

Tools.install(TeamPage, 'TeamPage');
Tools.install(Profile, 'Profile');
Tools.install(ProfileRegistration, 'ProfileRegistration');
